import React from 'react';
import { ChromePicker } from 'react-color';
import { COLORS } from '../utils/Color'


const formatter = new Intl.NumberFormat('pt-BR');


export class ColorFrame extends React.Component {


    constructor(props) {
        super(props)
        this.fadeTimer = 0
        this.requestTimer = 0
        this.props.app.colorFrame = this
        this.state = {
            hexColor: "#000000",
            colorIndex: -1,
            hoverColorID: -1,
            dbTrainingData: [],
            dbTestData: [],
            nMyTrainingColors: 0,
            nMyTestColors: 0,
            status: "",
            showTrainingData: true,
            popupID: -1,
        }
    }


    componentDidMount() {
        this.loadData()
        this.requestTimer = setInterval(() => this.loadData(), 10000)
    }


    componentWillUnmount() {
        clearInterval(this.requestTimer)
    }


    updateColor(hexColor, label) {
        this.setState({ hexColor: hexColor, colorIndex: label })
    }


    loadData() {
        this.requestTrainingData()
        this.requestTestData()
    }


    updateData(forTraining) {
        this.loadData()
        this.setState({ showTrainingData: forTraining })
    }


    // popup ----------------------------------------------------------------------------

    onContextMenu(event, uid) {
        this.showPopup(event, uid)
    }

    showPopup(event, uid) {
        event.preventDefault()
        this.setState({ popupID: uid, hoverColorID: -1 })
    }


    hidePopup() {
        this.setState({ popupID: -1 })
    }


    onDeleteColor(uid) {
        this.props.database.deleteColor(uid, this)
    }


    // training data ----------------------------------------------------------------------------


    requestTrainingData() {
        this.props.database.requestTrainingData(this)
    }


    receiveTrainingData(data) {
        if (data !== undefined) {
            let nCount = this.getMyColorsCount(data)
            this.setState({ dbTrainingData: data, nMyTrainingColors: nCount })
        }
    }


    getNextTrainingData(index) {
        let elem = undefined
        if (index < this.state.dbTrainingData.length) {
            elem = this.state.dbTrainingData[index]
        }
        return elem
    }


    // test data ----------------------------------------------------------------------------


    requestTestData() {
        this.props.database.requestTestData(this)
    }


    receiveTestData(data) {
        if (data !== undefined) {
            let nCount = this.getMyColorsCount(data)
            this.setState({ dbTestData: data, nMyTestColors: nCount })
        }
    }


    getNextTestData(index) {
        let elem = undefined
        if (index < this.state.dbTestData.length) {
            elem = this.state.dbTestData[index]
        }
        return elem
    }


    // insert color ----------------------------------------------------------------------------


    insertColor(hexColor, label, creator, training) {
        this.props.database.insertColor(hexColor, label, creator, training ? 1 : 0, this)
    }


    receiveInsertOk() {
        this.setState({ status: "+Color stored.", colorIndex: -1 })
        this.loadData()
    }


    receiveDeleteOk() {
        //this.setState({status: "+Color deleted.", colorIndex: -1})
        this.loadData()
    }


    // miscellaneous ----------------------------------------------------------------------------


    getMyColorsCount(colorList) {
        let nCount = 0
        for (let i = 0; i < colorList.length; i++) {
            if (colorList[i].creatorID === this.props.user.matrnr) {
                nCount++
            }
        }
        return nCount
    }


    receiveDatabaseError(error) {
        this.setState({ status: "#" + error });
    }


    onColorPicked(col) {
        this.setState({
            hexColor: col.hex,
            colorIndex: -1
        })
    }


    setColorIndex(event) {
        this.setState({ colorIndex: Math.trunc(event.target.id) })
    }


    storeColor(hexColor, label, training) {
        this.eraseStatus()
        if (label < 0) {
            this.setState({ status: "#Please, select a color name." })
        }
        else {
            this.insertColor(hexColor, label, this.props.user.matrnr, training)
        }
        this.fadeTimer = setInterval(() => this.eraseStatus(), 2000)
    }


    eraseStatus() {
        if (this.fadeTimer > 0) {
            clearInterval(this.fadeTimer)
            this.fadeTimer = 0
        }
        this.setState({ status: "" })
    }


    // render methods ----------------------------------------------------------------------------


    renderColorSelectors() {
        let jsx = []
        for (let i = 0; i < COLORS.length; i++) {
            jsx.push(
                <div
                    className={"ColorSelector" + (i === this.state.colorIndex ? "Chosen" : "")}
                    key={"COLOR_SELECTOR" + i}
                    id={i}
                    onClick={(event) => this.setColorIndex(event)}
                >
                    {COLORS[i]}
                </div>
            )
        }
        return jsx;
    }


    onMouseOutOfColorBox(event, uid) {
        let e = document.getElementById("DB_COLOR" + uid)
        let leaveRight = false
        if (e !== null) {
            let rect = e.getBoundingClientRect()
            leaveRight = (event.clientX >= rect.right)
        }
        this.setState({ hoverColorID: -1, popupID: (leaveRight ? this.state.popupID : -1) })
    }


    renderDBColors(colorList, showMine) {
        let jsx = []
        for (let elem of colorList) {
            if ((showMine && elem.creatorID === this.props.user.matrnr) || (!showMine && elem.creatorID !== this.props.user.matrnr)) {
                jsx.push(
                    <div
                        className="DBColorItem"
                        key={"DB_COLOR" + elem.uid}
                        id={"DB_COLOR" + elem.uid}
                        onMouseOver={() => this.setState({ hoverColorID: elem.uid })}
                        onMouseOut={(event) => this.onMouseOutOfColorBox(event, elem.uid)}
                        onClick={(event) => this.onContextMenu(event, elem.uid)}
                        style={{
                            backgroundColor: elem.hexColor,
                            color: elem.hexColor
                        }}>
                        {elem.label + "." + elem.creatorID}
                    </div>
                )
                if (elem.uid === this.state.popupID) {
                    let e = document.getElementById("DB_COLOR" + elem.uid)
                    if (e !== null) {
                        let r = e.getBoundingClientRect()
                        jsx.push(
                            <div
                                className="DeleteMenu"
                                key="Bin"
                                onClick={() => this.onDeleteColor(elem.uid)}
                                onMouseOut={() => this.setState({ popupID: -1 })}
                                style={{
                                    left: r.right,
                                    top: r.top,
                                    width: 80
                                }}>
                                &#9664;&nbsp;Delete&nbsp;&nbsp;<b>&#10005;</b>
                            </div>
                        )
                    }
                }
            }
        }
        return jsx
    }



    renderSharedColors() {
        let colorList = null
        let nMyCount = 0
        if (this.state.showTrainingData) {
            colorList = this.state.dbTrainingData
            nMyCount = this.state.nMyTrainingColors
        }
        else {
            colorList = this.state.dbTestData
            nMyCount = this.state.nMyTestColors
        }
        return (
            <div>
                <div className="DBSectionHeader">Colors</div>
                <div className="DBSize">{nMyCount}</div>
                <div className="DBSectionContent">
                    {this.renderDBColors(colorList, true)}
                </div>

            </div>
        )
    }


    renderDBHeader() {
        return (
            <div className="DBHeader">
                <div
                    className={"DBColorsHeader" + (this.state.showTrainingData ? "" : "Back")}
                    onClick={() => this.updateData(true)}
                >
                    {"Training Data \u2015 "}
                    {formatter.format(this.state.dbTrainingData.length)}
                </div>
                <div
                    className={"DBColorsHeader" + (this.state.showTrainingData ? "Back" : "")}
                    onClick={() => this.updateData(false)}
                >
                    {"Test Data \u2015 "}
                    {formatter.format(this.state.dbTestData.length)}
                </div>
                <div
                    className="DBSwitch"
                    onClick={() => this.setState({ showTrainingData: !this.state.showTrainingData })}>
                </div>
            </div>
        )
    }


    renderColorPicker() {
        return (
            <div className="ColorPickerFrame">
                <ChromePicker
                    color={this.state.hexColor}
                    onChangeComplete={(col) => this.onColorPicked(col)}
                    onChange={(col) => this.onColorPicked(col)}
                    disableAlpha={true}
                    width={"calc(var(--colorPickerWidth) - 20px)"}
                />
                <div className="LeftSpace" />
                <div className="RightSpace" />
                <div className="BottomSpace" />
                <div className="ColorPickerBottom" />
                <div className="PickedColor" style={{ background: this.state.hexColor }} />
                <div className="ColorSelectorFrame">
                    {this.renderColorSelectors()}
                </div>
                <div
                    className="AddButton"
                    onClick={() => this.storeColor(
                        this.state.hexColor,
                        this.state.colorIndex,
                        this.state.showTrainingData)
                    }>
                    Add
                </div>
                <div className={"Status" + (this.state.status.charAt(0) === '#' ? "Error" : "")}>
                    {this.state.status.substring(1)}
                </div>
            </div>
        )
    }


    renderHoverColor() {
        if (this.state.hoverColorID >= 0) {
            let e = document.getElementById("DB_COLOR" + this.state.hoverColorID)
            if (e !== null) {
                let innerTextSplit = e.innerText.split(".")
                let r = e.getBoundingClientRect()
                return (
                    <div
                        className="DBHover"
                        style={{
                            left: r.left - 27,
                            top: r.top + 1
                        }}>
                        <div className="DBHoverText">
                            &#9664;&nbsp;
                            <b>
                                {COLORS[innerTextSplit[0]]}
                            </b>
                            &nbsp;
                            {/*"/ " + innerTextSplit[1].toUpperCase()*/}
                        </div>
                    </div>
                )
            }
        }
        return null
    }


    render() {
        if (this.props.showColorFrame) {
            return (
                <div className="ColorFrame">
                    {this.renderHoverColor()}
                    <div className="ColorTopFrame">
                        {this.renderColorPicker()}
                    </div>
                    <div className="ColorBottomFrame">
                        {this.renderDBHeader()}
                        <div className="DBColorsFrame">
                            {this.renderSharedColors()}
                        </div>
                    </div>
                </div>
            )
        }
        return null
    }


}